/**
 * Utility functions for offer description functionality
 */

const MAX_OFFER_DESCRIPTION_POSITION = 3

/**
 * Determines if a description should be shown for an offer based on position and filters
 * @param position - The position of the offer in the list (0-based)
 * @param naturalLanguageQuery - Whether a natural language query is present
 * @returns true if description should be shown
 */
export function shouldShowOfferDescription(
  position: number | undefined,
  naturalLanguageQuery: string | undefined
): boolean {
  return !!(
    naturalLanguageQuery &&
    position !== undefined &&
    position < MAX_OFFER_DESCRIPTION_POSITION
  )
}
